import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

export default function DashboardSelector({
  ismultiple = false,
  isdisabled = false,
  borderTrue = true,
  selectedOption 
}) {

    if(!selectedOption){
        selectedOption = "CCN Dashboard"
    }
  const navigate = useNavigate();
  const [selectedAgency, setSelectedAgency] = useState(null);

  // List of available dashboards
  const list = [
    { label: "Subscription Dashboard", value: "/dashboard" },
    { label: "WAH Dashboard", value: "/wah" },
    { label: "MRB Dashboard", value: "/MRB_dashboard" },
    { label: "CCN Dashboard", value: "/ccn" },
  ];

  // Set default selected option if provided
  useEffect(() => {
    if (selectedOption) {
      const defaultValue = list.find(
        (item) =>
          item.label.toLowerCase().includes(selectedOption.toLowerCase()) ||
          item.value.toLowerCase().includes(selectedOption.toLowerCase())
      );
      if (defaultValue) {
        setSelectedAgency(defaultValue);
      }
    }
  }, [selectedOption]);

  const handleChange = (selected) => {
    setSelectedAgency(selected);
    if (!ismultiple && selected?.value) {
      navigate(selected.value);
    }
  };

  return (
    <Select
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
      })}
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          borderColor: "#9FAFCA",
          borderWidth: "3px",
          borderTop: !borderTrue && "none",
          borderLeft: !borderTrue && "none",
          borderRight: !borderTrue && "none",
          boxShadow: borderTrue ? "none" : undefined,
          "&:hover": {
            borderColor: "#2684FF",
          },
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          color: "#a71e1e",
        }),
        placeholder: (provided) => ({
          ...provided,
          color: "#6c757d",
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? "#9FAFCA" : "white",
          color: state.isSelected ? "white" : "black",
          "&:hover": {
            backgroundColor: "#9FAFCA",
            color: "white",
          },
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
          borderRadius: 0,
        }),
      }}
      options={list}
      value={selectedAgency}
      onChange={handleChange}
      placeholder="Select Dashboard"
      isMulti={ismultiple}
      isDisabled={isdisabled}
      isSearchable={false}
    />
  );
}
